<template>
  <div>
    <slot v-bind="{ show, toggle, showPreloader, loadCaptcha }"></slot>
  </div>
</template>
<script>
import recaptchaInit from "@/model/grecaptcha";

export default {
  props: {
    defaultHidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.$props.defaultHidden === false,
      showPreloader: false
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    loadCaptcha($event) {
      console.log(this.$el, "EL");
      const grecaptchaResponse = this.$el.querySelector(
        ".g-recaptcha-response"
      );

      if (!grecaptchaResponse.value) {
        $event.stopPropagation();
        $event.preventDefault();
        this.showPreloader = true;
        this.executeCaptcha();
      }
    },
    executeCaptcha() {
      const grecaptchaResponse = this.$el.querySelector(
        ".g-recaptcha-response"
      );

      recaptchaInit().then(grecaptcha => {
        grecaptcha.ready(() => {
          try {
            window.grecaptcha
              .execute(grecaptchaResponse.getAttribute("data-sitekey"), {
                action: "validate_captcha"
              })
              .then(token => {
                grecaptchaResponse.value = token;
                this.$el.querySelector("[name='send']").click();
                this.showPreloader = false;
              });
          } catch (error) {
            console.log(error, "grecaptcha error");
            this.showPreloader = false;
          }
        });
      });
    }
  }
};
</script>
